const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 智能音频模块
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x04FF,
//     PROMPT_TONE_UUID: 0x0500,
//     RECORDING_UUID: 0x0501,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMAU extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMAUDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'ymAU';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMAU(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'ymAU',
            name: formatMessage({
                id: 'YMAU.categoryName',
                default: 'YM AU',
                description: 'Label for the YM AU extension category'
            }),
            color1: "#E91E63",
            color2: "#D51A5C",
            color3: "#C21655",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.ble.connect',
                        default: 'connect to YM-AU-[DEVICE_NAME]',
                        description: 'Connect to YM AU'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.ble.disconnect',
                        default: 'disconnect from YM AU',
                        description: 'Disconnect from YM AU'
                    })
                },
                {
                    opcode: 'setPromptTone',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.setPromptTone',
                        default: 'play tone [PROMPT_TONE]',
                        description: 'Set prompt tone'
                    }),
                    arguments: {
                        PROMPT_TONE: {
                            type: ArgumentType.NUMBER,
                            menu: 'promptTone',
                            defaultValue: '1',
                        }
                    }
                },
                {
                    opcode: 'startRecording',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.startRecording',
                        default: 'start recording',
                        description: 'Start recording audio'
                    })
                },
                {
                    opcode: 'stopRecording',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.stopRecording',
                        default: 'stop recording',
                        description: 'Stop recording audio'
                    })
                },
                {
                    opcode: 'playRecording',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMAU.playRecording',
                        default: 'play recording',
                        description: 'Play the recorded audio'
                    })
                }
            ],
            menus: {
                promptTone: {
                    
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.1',
                                default: '1',
                                description: 'tone 1'
                            }),
                            value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.2',
                                default: '2',
                                description: 'tone 2'
                            }),
                            value: '2'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.3',
                                default: '3',
                                description: 'tone 3'
                            }),
                            value: '3'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.4',
                                default: '4',
                                description: 'tone 4'
                            }),
                            value: '4'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.5',
                                default: '5',
                                description: 'tone 5'
                            }),
                            value: '5'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.6',
                                default: '6',
                                description: 'tone 6'
                            }),
                            value: '6'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.7',
                                default: '7',
                                description: 'tone 7'
                            }),
                            value: '7'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.setPromptTone.8',
                                default: '8',
                                description: 'tone 8'
                            }),
                            value: '8'
                        },
                    ]
                },
                recordingState: {
                    acceptReporters: true,
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMAU.recordingState.recording',
                                default: 'recording',
                                description: 'Recording state: recording'
                            }),
                            value: 'recording'
                        },
                        {
                            text: formatMessage({
                                id: 'YMAU.recordingState.stopped',
                                default: 'stopped',
                                description: 'Recording state: stopped'
                            }),
                            value: 'stopped'
                        }
                    ]
                }
            }
        }];
    }

    async connect(args) {
        const deviceName = 'YM-AU-' + (args.DEVICE_NAME?.trim() || "");
        console.log("this.bleUtils.device audio", this.bleUtils.device);
        const connected = await this.isConnected();
        if (connected) {
            console.log('Already connected to device');
            return;
        }
        console.log(`Connecting to YM AU device: ${deviceName}`);
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM AU device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async setPromptTone(args) {
        console.log('Setting prompt tone');
        const promptTone = args.PROMPT_TONE;
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.music);
                const promptToneValue = parseInt(promptTone, 10);
                if (isNaN(promptToneValue)) {
                    console.error('Invalid promptTone value:', promptToneValue);
                    return;
                }
                const promptToneArray = new Uint8Array(1);
                promptToneArray[0] = promptToneValue;
                await this.bleUtils.writeCharacteristic(characteristic, promptToneArray);
            } catch (error) {
                console.error('Failed to set promptTone:', error);
            }
        }
    }

    async startRecording() {
        console.log('Starting recording');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.recordControl);
                const startCommand = new Uint8Array([1]);
                await this.bleUtils.writeCharacteristic(characteristic, startCommand);
                console.log('Recording started');
            } catch (error) {
                console.error('Failed to start recording:', error);
            }
        }
    }

    async stopRecording() {
        console.log('Stopping recording');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.recordControl);
                const stopCommand = new Uint8Array([2]);
                await this.bleUtils.writeCharacteristic(characteristic, stopCommand);
                console.log('Recording stopped');
            } catch (error) {
                console.error('Failed to stop recording:', error);
            }
        }
    }

    async playRecording() {
        console.log('Playing recording');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.recordControl);
                const playCommand = new Uint8Array([3]);
                await this.bleUtils.writeCharacteristic(characteristic, playCommand);
                console.log('Playing recording');
            } catch (error) {
                console.error('Failed to play recording:', error);
            }
        }
    }

}

module.exports = ScratchYMAUDevice;